import { AfterViewChecked, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { ReactiveFormsModule, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { debounceTime, Observable, Subscription } from 'rxjs';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ApiService } from 'src/app/services/api.service';
import { ExcelService } from 'src/app/services/excelService';
import { FormValidation } from 'src/app/services/FormValidation';
import { UtilService } from 'src/app/services/util.service';
import Swal from 'sweetalert2';
import { modifyTitle } from '../customer-jobs/customer-jobs.component';
import { CustomerService, TEXT_FIELDS } from '../customer-service.service';
import { ManageSlotComponent } from '../manage-slot/manage-slot.component';
import { MtaFilterPipe } from 'src/app/pipe/name-filter.pipe';
import { TimezoneDatePipe } from 'src/app/timezone-date.pipe';
import { PlanCardComponent } from '../plan-card/plan-card.component';
import { CustomerSearchComponent } from '../customer-search/customer-search.component';
import { NodataFoundComponent } from '../../../../widget/nodata-found/nodata-found.component';
import { CONTRACT_ROLES } from '../company/company.service';
import { ModalPopupComponent } from '../modal-popup/modal-popup.component';
import { MODAL_OPTIONS } from 'src/app/services/FormValidation';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-customer-user',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, NgxDatatableModule, ManageSlotComponent,
MtaFilterPipe, TimezoneDatePipe, TitleCasePipe, PlanCardComponent, CustomerSearchComponent, NodataFoundComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './customer-user.component.html',
  styleUrls: ['./customer-user.component.scss', '../../../../../styles/admin/style.scss', '../../../../../styles/admin/app.scss']
})
export class CustomerUserComponent extends FormValidation implements OnInit, OnDestroy, AfterViewChecked {
  businessId: any;
  businessEmail: any;
  refreshSubcription: Subscription;
  filterSubscription: Subscription;
  searchSubscription: Subscription;
  adminCount: any;
  role:any
  activate = new EventEmitter();
  allocationCards = [
    {
      name: "Total Users",
      value: null
    },
    {
      name: "Active App Users",
      value: null
    },
    {
      name: "Administrators",
      value: null
    },
  ]
  MemberShipType:any
  constructor(
    private modalService: BsModalService,
    private customerService: CustomerService,
    private router: Router,
    private _activated_route: ActivatedRoute,
    private _api_service: ApiService,
    public util: UtilService,
    private excelService: ExcelService,
    private renderer: Renderer2, private el: ElementRef

  ) {
    super();

    this._activated_route.parent.data.subscribe(res => {
      this.businessId = res.data.id
      this.MemberShipType = res.data.plan;
      this.role=res.data.role;
      this.businessName = res.data.businessName;
      this.bid = res.data.bid;
      this.businessEmail = res.data.businessEmail
    });
   //Refreshing the users list
    this.refreshSubcription = this.customerService.getRefreshKey().subscribe(res => {
      if (res === 'user') {
        this.fetchData();
      }
    });

    // Filter the users list by monisha
    this.filterSubscription = this.customerService.getFilterValue().subscribe(res => {
      if (res.key === 'user') {
        this.userPayload.page = 0;
        this.userPayload.enabled = res.value.enabled;
        this.userPayload.statusList = res.value.status != null ? [res.value.status] : null;
        this.userPayload.roleList = res.value.role != null ? [res.value.role] : null;
        this.userPayload.planAccessStatus = res.value.planAccessStatus != null ? [res.value.planAccessStatus] : null;
        this.userPayload.searchContent = null;
        this.customerService.setFilterPayload(this.userPayload);
        this.fetchData();
      }
    });

 // Search the users list by monisha
    this.searchSubscription = this.customerService.getSearchValue().pipe(
      debounceTime(1000),
    ).subscribe(response => {
      if (response.key === "user") {
        this.userPayload.page = 0;
        this.userPayload.searchContent = response.value.trim();
        this.fetchData();
      }
    });

  }

  listToShow: Array<any>;
  textFields: Array<Partial<TEXT_FIELDS>> = [];
  userForm  !: FormGroup<any>;
  ngOnInit(): void {
    this.addUserForm();
      this.fetchData();
    this.textFields = [
      { label: "User", key: "fullName", value: null, type: "STRING" },
      { label: "Email ID", key: "username", value: null, type: "STRING" },
      { label: "Gigsumo ID", key: "gigsumoNo", value: null, type: "STRING" },
      { label: "Role", key: "userType", value: null, type: "STRING" },
      { label: "Start Date", key: "createdOn", value: null, type: "DATE" },
      { label: "Last Active", key: "lastLoggedIn", value: null, type: "DATE" },
      { label: "Plan Access", key: "planAccessStatus", value: null, type: "STRING" },
      { label: "Status", key: "userStatus", value: null, type: "STRING" },
    ]
  }

  scrollSynced = false; // Flag to prevent multiple bindings
  bodyScrollUnlistener: () => void; // To store the unlistener for clean-up
  resizeUnlistener: () => void; // To store resize unlistener

  ngAfterViewChecked() {
    const dataTableBody = this.el.nativeElement.querySelector('.datatable-body');
    const dataTableHeader = this.el.nativeElement.querySelector('.datatable-header');

    if (!this.isFirefox()) {
      // If it's not Firefox, no need for custom scroll handling
      return;
    }

    if (dataTableBody && dataTableHeader && !this.scrollSynced) {
      // Clean up any previous listeners to avoid duplicates
      if (this.bodyScrollUnlistener) {
        this.bodyScrollUnlistener();
      }
      if (this.resizeUnlistener) {
        this.resizeUnlistener();
      }

      // Scroll listener to sync body and header scrolls
      this.bodyScrollUnlistener = this.renderer.listen(dataTableBody, 'scroll', this.throttle(() => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      }, 10)); // Throttle the scroll event to improve performance

      // Listener for window resize to ensure the header remains aligned
      this.resizeUnlistener = this.renderer.listen(window, 'resize', () => {
        dataTableHeader.scrollLeft = dataTableBody.scrollLeft;
      });

      this.scrollSynced = true; // Mark scroll syncing as done
    }
  }

  // Browser detection function to check if the browser is Firefox
  isFirefox(): boolean {
    return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
  }


  throttle(fn: Function, wait: number) {
    let time = Date.now();
    return function () {
      if ((time + wait - Date.now()) < 0) {
        fn();
        time = Date.now();
      }
    };
  }

  ngOnDestroy(): void {

    if (this.refreshSubcription) {
      this.refreshSubcription.unsubscribe();
    }

    if (this.filterSubscription) {
      this.filterSubscription.unsubscribe();
    }

    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.bodyScrollUnlistener) {
      this.bodyScrollUnlistener();
    }
    if (this.resizeUnlistener) {
      this.resizeUnlistener();
    }
  }
  //To sort the userslisting, pagenumber still stayed in same page by monisha
  @ViewChild('sortTable') table: any;
  onSort(event) {
    const currentPage = this.userPayload.page;
    this.table.offset = currentPage;
}


  nextPage(data: any) {
    this.userPayload.page = data.offset;
    if (this.userPayload.page == 0) {
      this.userPayload.page = 0;
    }
    this.userPayload.limit = 10;
    this.fetchData();
  }


  public selected = [];
  onSelect({ selected }) {
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  businessName: string;
  bid: string;
  userPayload: any = {
    limit: 10,
    page: 0,
    statusList:["ACTIVE","INACTIVE","BLOCKED","INITIATED"],
    groupType: "LISTING"
  }
  getBusinessDetails(businessId: string): Observable<any> {
    return this._api_service.query('business/details/' + businessId);
  }

  getCustomerUsersList(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findEmployeeBenefitsAllocation', payload);
  }
  getuserallocationlist(payload: Object): Observable<any> {
    return this._api_service.create('subscription/findUserWithBenefitAllocation', payload);
  }
  readonly contractRolesMap = CONTRACT_ROLES;

  formatUserType(userType: string): string {
    return userType?.replace(/_/g, ' ');
  }

  getContractRoleLabels(row: any): string {
    const roles: string[] = row?.contractRoles || [];
    if (roles.length > 0) {
      return roles.map(r => this.contractRolesMap.find(cr => cr.value === r)?.label || r).join(', ');
    }
    const rawType = row?.userType?.replace(/\s/g, '_')?.toUpperCase();
    if (rawType === 'SUPERADMIN' || rawType === 'ADMIN') {
      return 'All (Admin)';
    }
    return '—';
  }

  totalUsers: number = 0;
  activetotalUsers: number = 0;
  fetchData() {
    this.util.startLoader();
    

    const isSuperAdmin = this.role === 'SUPERADMIN' && ['Starter', 'Growth','ScaleX'].includes(this.MemberShipType);
//If business super admin is the business or enterprise plan we called fetchCustomerUsers() function by monisha.This is for Business Users allocation.
    if (isSuperAdmin) {
      this.userPayload.businessId = this.businessId;
      this.userPayload.email = this.businessEmail;
      this.fetchCustomerUsers();
    } else {
            //otherwise called fetchUserAllocation() function by monisha. This is for individual users allocation.
      this.userPayload.userId = localStorage.getItem('userId');
      this.fetchUserAllocation();
    }
  }

  private fetchCustomerUsers() {
    this.getCustomerUsersList(this.userPayload).subscribe({
      next: (res) => {
        this.util.stopLoader();
        this.handleApiResponse(res, true);
      },
      error: (error) => this.handleApiError(error)
    });
  }

  private fetchUserAllocation() {
    this.getuserallocationlist(this.userPayload).subscribe({
      next: (res) => {
        this.util.stopLoader();
        this.handleApiResponse(res, false);
      },
      error: (error) => this.handleApiError(error)
    });
  }

  private handleApiResponse(res: any, isSuperAdmin: boolean) {
    if (res && res.code === "00000") {
      if (isSuperAdmin) {
        this.processSuperAdminResponse(res);
      } else {
        this.processUserAllocationResponse(res);
      }
    }
  }

  private processSuperAdminResponse(res: any) {
    this.listToShow = res.data.customerUserAllocationList || [];

    this.listToShow.forEach(x => {
      if (x.userType !== null) {
        x.userType =x.userType && x.userType.replaceAll("_", " ");
      }
    });

    this.totalUsers = res.data.totalUsers || 0;
    this.adminCount = res.data.businessAdminCount || 0;
    this.activetotalUsers = res.data.activeUsersCount || 0;

    this.updateAllocationCards(this.totalUsers, this.activetotalUsers, this.adminCount);
    this.excelService.setCount(this.totalUsers);
    this.customerService.setUserData(this.listToShow);
  }

  private processUserAllocationResponse(res: any) {
    this.listToShow = Array.isArray(res.data.userWithBenefit) ? res.data.userWithBenefit : [res.data.userWithBenefit];
    this.listToShow.forEach(x => {
      if (x.userType !== null) {
        x.userType = x.userType && x.userType.replaceAll("_", " ");
      }
    });

    // Setting default values as there's only one user
    this.totalUsers = 1;
    this.adminCount = 0;
    this.activetotalUsers = 1;

    this.updateAllocationCards(this.totalUsers, this.activetotalUsers, this.adminCount);
    this.excelService.setCount(this.totalUsers);
    this.customerService.setUserData(this.listToShow);
  }

  private updateAllocationCards(total: number, active: number, admin: number) {
    this.allocationCards[0].value = total;
    this.allocationCards[1].value = active;
    this.allocationCards[2].value = admin;
  }

  private handleApiError(error: any) {
    this.util.stopLoader();
    console.error('Subscribe Error:', error);
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while fetching data. Please try again later.",
    });
  }


  handleInvalidSession() {
    Swal.fire({
      icon: "info",
      title: "Invalid session",
      text: "Sorry, your session has expired. We are routing you to login page.",
      showConfirmButton: false,
      timer: 5000,
    }).then(() => {
      localStorage.clear();
      this.router.navigate(['/auth/login']);
      this.util.stopLoader();
      Swal.close();
    });
  }

  mergeNames(firstName: string, lastName: string): string {
    return firstName + " " + lastName;
  }

  addUserForm() {

    this.userForm = new FormGroup({
      usersList: new FormArray([])
    });

    this.pushUserFields();
    //
    // console.log(this.userForm);

  }

  get userFormArr() {
    return (this.userForm.get('usersList') as FormArray);
  }


  pushUserFields() {
    const fields = new FormGroup({
      firstName: new FormControl('', Validators.required),
      lastName: new FormControl('', Validators.required),
      email: new FormControl('', Validators.required),
      role: new FormControl('Role', Validators.required),
    });

    this.userFormArr.push(fields);
  }

  removeUser(index: number) {
    this.userFormArr.removeAt(index);
  }

  ref: BsModalRef;
  openModal(content) {
    this.modalService.show(content, { backdrop: 'static', keyboard: false, });
  }

  openModalUsingComponent() {
    const data: any = {
      backdrop: 'static',
      keyboard: false,
      size: "xl",
      title: "Jobs/Candidates Slot"
    };
    this.ref = this.modalService.show(ManageSlotComponent, data);
  }

  resetFields(){
    this.textFields.forEach(x => {
      x.value = null;
    });
  }

  openEdit(datas: any) {
    this.resetFields();
    this.textFields = modifyTitle(this.textFields , this.MemberShipType === "Free" ? true : false);

    if (datas) {
      Object.keys(datas).map(key => {
        this.textFields.forEach(v => {

          if(v.key === "planAccessStatus"){
            v.value = datas[v.key] === "ACTIVE" ? "Given" : (datas[v.key] != "N/A" ? "Not given" : datas[v.key]);
            return;
          }

          if(v.key === "userType"){
            v.value = datas[v.key] ? this.util.userAlias(datas[v.key]) : "N/A";
            return;
          }

          if (v.key == key) {
            v.value = datas[key];
          }

        });
      });
    }

    if (this.textFields) {
      const isSuperAdminPaidPlan = this.role === 'SUPERADMIN' && ['Starter', 'Growth', 'ScaleX'].includes(this.MemberShipType);
      this.util.startLoader();
      const initialState: any = {
        title: 'User',
        fields: this.textFields,
        showContractRoles: isSuperAdminPaidPlan,
        user: datas,
        businessId: this.businessId
      };
      this.modalService.show(ModalPopupComponent, { ...MODAL_OPTIONS, initialState });
      this.modalService.onHide.subscribe(() => {
        this.isModalOpen = false;
        this.fetchData();
      });
      setTimeout(() => { this.util.stopLoader(); }, 500);
    }

  }

  closeModal() {
    this.modalService.hide(10);
  }


}
